<div class="w-full px-5 py-6 lg:px-8 lg:py-8">
  <!-- Header row: greeting + filters -->
  <div class="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
    <div class="min-w-0">
      <div class="text-xs font-semibold uppercase tracking-[0.32em] text-white">
        {{ getGreeting() }},
      </div>
      <h1 class="mt-1 text-4xl font-semibold tracking-wide bg-linear-to-r from-white via-[#88D3EE] to-white bg-clip-text text-transparent">
        Brooklyn Benson
      </h1>
    </div>

    <div class="w-full lg:w-auto lg:min-w-[720px]">
      @if (filterOptions(); as opts) {
         <app-dashboard-filter-bar (applyFilters)="onFiltersChange($event)" />
      } @else {
        <div class="h-10 w-full rounded-md border border-white/10 bg-white/5"></div>
      }
    </div>
  </div>

  <!-- Cards grid -->
  <div class="mt-6 grid grid-cols-1 gap-6 xl:grid-cols-12">
    <div class="xl:col-span-7 h-full">
      <app-matrix-analytics-card class="block h-full" [externalFilters]="filtersAsRecord()" />
    </div>
    <div class="xl:col-span-5 h-full">
      <app-matrix-tracker-card class="block h-full" />
    </div>
  </div>

  <!-- Lower grid: left stack (AI Videos + Feature Comparison), right spans both (Investigation) -->
  <div class="mt-6 grid grid-cols-1 gap-6 xl:grid-cols-12">
    <div class="xl:col-span-5 flex flex-col gap-6">
      <app-midas-ai-videos-card  />
      <app-feature-comparison-card />
    </div>
    <div class="xl:col-span-7 h-full">
      <app-matrix-investigation-card class="h-full"  [externalFilters]="filtersAsRecord()" />
    </div>
  </div>
</div>
